export const PRODUCT_ACCOUNTING_SLUGS_BY_PRICE_TYPE = {
  saleEnabled: [
    "product_price_saleDebitAccount",
    "product_price_saleCreditAccount",
    "product_price_saleVatDebit",
    "product_price_saleVatCredit",
  ],
  purchaseEnabled: [
    "product_price_purchaseDebitAccount",
    "product_price_purchaseCreditAccount",
    "product_price_purchaseVatDebit",
    "product_price_purchaseVatCredit",
  ],
  rentEnabled: [
    "product_price_rentDebitAccount",
    "product_price_rentCreditAccount",
    "product_price_rentVatDebit",
    "product_price_rentVatCredit",
  ],
  rentoutEnabled: [
    "product_price_rentoutDebitAccount",
    "product_price_rentoutCreditAccount",
    "product_price_rentoutVatDebit",
    "product_price_rentoutVatCredit",
  ],
} as const satisfies Record<string, readonly string[]>;

export const PRODUCT_ACCOUNTING_FIELD_SLUGS: readonly string[] = Object.values(
  PRODUCT_ACCOUNTING_SLUGS_BY_PRICE_TYPE,
).flat();
